<template>
  <div class="box">
    <admin-box-item title="선택한 상품종류 화면">
      <scroll-table-wrapper :enableDragScroll="true">
        <div class="img-container unselect">
          <img class="preview" v-for="(url,idx) in previewUrls" :key="`preview-${idx}`" :src="url">
        </div>
      </scroll-table-wrapper>
    </admin-box-item>
  </div>
</template>

<script>
  import ScrollTableWrapper from "../../../module/common/ScrollTableWrapper";
  export default {
    name: "ProductPreview",
    components: {ScrollTableWrapper},
    props: {
      prod: {
        type: Object
      }
    },
    data() {
      return {
        call: {
          inquiry: {
            0: ['0_1'],
            2: ['2_1', '2_2'],
          }
        },
        delivery: {
          inquiry: {
            0: ['0_1', '0_2'],
            1: ['1_1', '1_2', '0_2'],
            2: ['1_1', '2_2', '0_2']
          }
        },
        reservation: {
          payment_type: {
            0: {
              inquiry: {
                0: ['0_0_1', '0_0_2'],
                1: ['0_1_1', '0_0_2', '0_1_3'],
                2: ['0_1_1', '0_0_2', '0_2_3']
              }
            },
            1: {
              inquiry: {
                0: ['0_0_1', '1_0_2'],
                1: ['0_1_1', '1_0_2', '0_1_3'],
                2: ['0_1_1', '1_0_2', '0_2_3'],
              }
            },
            2: {
              inquiry: {
                0: ['0_0_1', '2_0_2'],
                1: ['0_1_1', '2_0_2', '0_1_3'],
                2: ['0_1_1', '2_0_2', '0_2_3'],
              }
            }
          }
        },
        booking: {
          payment_type: {
            0: {
              inquiry: {
                0: ['0_0_1', '0_0_2'],
                1: ['0_1_1', '0_0_2', '0_1_3'],
                2: ['0_1_1', '0_0_2', '0_2_3']
              }
            },
            1: {
              inquiry: {
                0: ['0_0_1', '1_0_2'],
                1: ['0_1_1', '1_0_2', '0_1_3'],
                2: ['0_1_1', '1_0_2', '0_2_3'],
              }
            }
          }
        },
        previewUrls: []
      }
    },
    created() {
      this.setPreview();
    },
    watch: {
      prod: {
        handler() {
          this.setPreview();
        },
        deep: true
      }
    },
    methods: {
      setPreview() {
        let url = `https://launchpack-storage.s3.ap-northeast-2.amazonaws.com/media/launchpack/preview_${this.prod.package}`;
        let result = [];
        if(['call','delivery'].indexOf(this.prod.package)>-1) {
          this[this.prod.package].inquiry[this.prod.inquiry_conversion_type].forEach(i=>{
            result.push(`${url}_${i}.png`);
          });
        }
        else {
          this[this.prod.package].payment_type[this.prod.payment_type].inquiry[this.prod.inquiry_conversion_type].forEach(i=>{
            result.push(`${url}_${i}.png`);
          });
        }

        this.previewUrls = result;
      }
    },
    computed: {
    }
  }
</script>

<style lang="stylus" scoped>
  .img-container
    display flex
    align-items center
    padding-bottom 12px
    cursor grab

  .preview
    width 204px
    border 1px solid #e3e3e3
    margin-right 12px
</style>
